import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../config/apiConfig";
import "./LoginPage.css";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const { data } = await axios.post(API.AUTH.FORGOT_PASSWORD, { email });
      setSuccess(
        data?.message ||
          "Se encontrarmos uma conta com este e-mail, enviaremos um link de recuperação."
      );
    } catch (err) {
      setError("Não foi possível enviar o e-mail de recuperação. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-redesign">
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--one" />
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--two" />

      <div className="auth-redesign__layout">
        <section className="auth-story">
          <img
            src="/assets/favicon.png"
            alt="Logo"
            className="w-16 -mb-2 -mt-3"
          />
          <h1>Conecte anunciantes rurais e compradores reais</h1>
          <p>
            Publique produtos do campo, receba contatos de interessados e
            acompanhe oportunidades de venda em um só lugar.
          </p>

          <div className="auth-story__metrics">
            <article className="metric-card">
              <strong>+3.200</strong>
              <span>anúncios rurais ativos</span>
            </article>
            <article className="metric-card">
              <strong>12 estados</strong>
              <span>compradores buscando fornecedores locais</span>
            </article>
            <article className="metric-card">
              <strong>Contato</strong>
              <span>negociação simples entre anunciante e comprador</span>
            </article>
          </div>
        </section>

        <section className="auth-card-v2 fade-in">
          <div className="auth-card-v2__header">
            <h2>Recuperar acesso</h2>
            <p>
              Informe o e-mail da sua conta. Vamos enviar um link para você
              criar uma nova senha.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="auth-card-v2__form">
            <div className="field">
              <label className="label">E-mail corporativo</label>
              <input
                className="input"
                name="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="voce@seunegocio.com.br"
                required
              />
            </div>

            {error ? <div className="alert">{error}</div> : null}
            {success ? <div className="alert alert--success">{success}</div> : null}

            <button
              className="button button--primary !shadow-sm"
              type="submit"
              disabled={loading}
            >
              {loading ? "Enviando..." : "Enviar link de recuperação"}
            </button>

            <p className="auth-card-v2__back-link">
              <Link to="/login">Voltar para o login</Link>
            </p>
          </form>
        </section>
      </div>
    </main>
  );
};

export default ForgotPasswordPage;
